// Sub-functions
import usr from "./user";
import rzkitchartupdate from "./chart";
import changeLanguage from "./lng";
import changeTheme, {replaceThemeElements, getCurTheme} from "./theme";
import setObserver from "./observer";
import "./send-message";
import "./simple-animation";

window.changelngglobal = [];

// eslint-disable-next-line no-unused-vars
const { $, dict, rz } = window; // autoComplete

// Check if redirect need
const redirectlabel = $("#redirect-label");
if (redirectlabel[0]) {
  const redirectto = $(redirectlabel[0]).attr("redirectto");
  if (redirectto) window.location.href = redirectto;
}

// const queryStringParams = new Proxy(new URLSearchParams(window.location.search), { get: (searchParams, prop) => searchParams.get(prop) });

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
window.addEventListener("scroll", (e) => {
  // document.documentElement.style.setProperty("--scrollTop", `${this.scrollY}px`);
});

// After load page
$(document).ready(async () => {
  // Get user settings and check user status
  window.cfg = await usr.userCheckStatus();

  // detect Presentation page
  const isPresentation = Boolean(document.location.pathname.startsWith("/presentation"));

  // Detect Active Language
  const curlng = dict.get();
  dict.set(curlng);

  // Detect curTheme
  const curtheme = getCurTheme();
  replaceThemeElements();

  // Replace some images for MobileVersion
  // replaceImagesForMobileVersion();

  // Set menu-item active
  $("#main-navbar, #offcanvas-navbar").find("a").each((i, item) => {
    if ($(item).attr("href") === window.location.pathname) {
      $(item).parent().addClass("uk-active");
      return 0;
    }
  });

  // Set language-button active
  const lgt = (isPresentation && curtheme === "light" ? "rz-button-dark" : "rz-button-light");
  const drk = (isPresentation && curtheme === "light" ? "rz-button-light" : "rz-button-dark");
  $("#set-lng-" + curlng).addClass(["active", drk]).removeClass([lgt]);
  $("#set-lng-" + (curlng === "ru" ? "en" : "ru")).addClass([lgt]).removeClass([drk]);

  // Show rz-main-container
  $(".rz-main-container").show().removeAttr("hidden");
  // Hide preloader. Show page content
  $("#preloader").fadeOut("slow"); $(".content").show(); $("body").removeClass("stop-scrolling");

  // Set first Observer: Change transparent of menubar when User scrolling
  const trg1 = $(".observer-target"); // First caption, example: <div class='observer-target'>Non-destructive laboratory (NDT)</div>
  const cnt1 = $(".observer-container"); // Top Menubar: Container & Marker
  if (trg1[0] && cnt1[0]) {
    const setMenuTransparent = () => {
      $(cnt1[0]).addClass("rz-transparent-remove").removeClass("rz-transparent-set");
    };
    const resetMenuTransparent = () => {
      $(cnt1[0]).addClass("rz-transparent-set").removeClass("rz-transparent-remove");
    };
    setObserver(cnt1[0], trg1[0], null, setMenuTransparent, resetMenuTransparent);
  }

  // Hide footer when scroll down full
  const trg2 = $(".observer-target2"); // Menu
  const cnt2 = $(".observer-container2"); // Footer
  const wndh = rz.windowSize().height; // Marker
  if (trg2[0] && cnt2[0]) {
    const setFooterHidden = () => {
      $(cnt2[0]).addClass("rz-vis-animate").removeClass("rz-hid-animate");
    };
    const setFooterVisible = () => {
      $(cnt2[0]).addClass("rz-hid-animate").removeClass("rz-vis-animate");
    };
    setObserver(cnt2[0], trg2[0], wndh, setFooterHidden, setFooterVisible);
  }

  // Update my chart for RZKIT-TABLE
  rzkitchartupdate();
});

// Change language
$("[id^='set-lng-']").on("click", async (e) => {
  e.preventDefault();
  await changeLanguage($(e.target).attr("id") === "set-lng-ru" ? "ru" : "en");
});

// Change theme
$("button#set-theme").on("click", async (e) => {
  e.preventDefault();
  await changeTheme();
});
